import { Ng2StateDeclaration } from '@uirouter/angular';

export const referralState: Ng2StateDeclaration[] = [
  {
    name: 'referral-decline',
    url: '/referral-decline?token',
    loadComponent: () =>
      import('./containers/referral-decline/referral-decline.component').then(m => m.ReferralDeclineComponent),
    data: {
      bodyClass: ['app-white']
    }
  },
  {
    name: 'referral-redirect',
    url: '/referral-redirect?url',
    loadComponent: () =>
      import('./containers/referral-redirect/referral-redirect.component').then(m => m.ReferralRedirectComponent),
    data: {
      bodyClass: ['app-white']
    }
  }
];
